<template >
  <div>
      
    <div class="container-flight margin_container_hf">
      <PDKModal
        :buttonObject="modalButtonProps"
        v-if="showTimerModal"
        @btnAction="onTimeoutModalAction"
      >
        <h3 slot="header">custom header</h3>
        <div style="text-align: center" slot="body">
          <img
            id="timer-logo"
            width="150"
            height="150"
            src="../../../public/img/out-of-ti.png"
          />
          <h4 style="margin-top: 10px">
            مدت زمان شما برای جستجو به پایان رسیده
          </h4>
        </div>
      </PDKModal>

      <ChangeSearch
        :showChangeSearch="isShowChangeSearch"
        :searchItems="searchItems"
      />

      
          
      <h3 class="title-type-1"><i class="icon-left-hand filter-icon"></i>پیشنهاد ما</h3>
      <Selected
        @onSelectPackage="onSelectPackage"
        @onChange="onChange"
        v-if="temp.availableFlights != null"
        :selectedType="step"
        :sleketonModel="skletonModel"
        :selectedFlight="selected"
        :selectedRoom="selectedRoom"
        :showPrice="isShowPrice"
        :isDisableButton="isDisableButton"
        :hotelDetails="hotelDetails"
      />
      <Selected v-else />
      
      <div v-if="step === 4" class="row">
        <Rooms @selected="onSelectRoom" :roomsAvail="roomsAvail"  :showPrice="isShowPrice" />
      </div>
      <div v-if="step < 4" class="row">
        <aside class="filter-sidebar col-lg-3 col-md-4 col-sm-12">
          <div v-if="step == 1" class="card">
            <div class="card-body">
              <h5 class="card-title">{{ $t("HomeHeader.DepartureFlightFilter") }}</h5>
              <hr />
              <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
  
                  <i class="icon-back-in-time filter-icon"></i> 
                </a>
                <Range
                  v-if="temp.availableFlights != null"
                  :values="TimesArray"
                  type="double"
                  @onFinish="filterByDepartureTime"
                />
                <Range :values="TimesArray" type="double" v-else />
                   <span class="highlight"></span><span class="bar"></span>
                <label for=""> {{ $t("HomeHeader.FlightTime") }}</label>
                
              </div>

              <div class="card-text mb-4"></div>
              <hr />
              <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-plane filter-icon"></i> {{ $t("Airlines") }}
                </a>
                <PdkAirlineFilter
                  v-if="temp.availableFlights != null"
                  :airlines="departureAirlines"
                />
                <PdkAirlineFilter v-else />
              </div>
              <div class="filter_type">
                <hr />
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-ticket-2 filter-icon"></i> {{ $t("HomeHeader.TicketType") }}
                </a>

                <ul>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                      :title=" $t('HomeHeader.Economy')"
                    />
                  </li>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                      :title=" $t('HomeHeader.Business')"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div v-if="step >= 2" class="card">
            <div class="card-body">
              <h5 class="card-title">فیلتر پرواز برگشت</h5>
              <hr />
              <div class="filter_type group_mdi">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon-back-in-time filter-icon"></i> 
                </a>
                <Range
                  v-if="temp.availableFlights != null"
                  :values="TimesArray"
                  type="double"
                  @onFinish="filterByReturnTime"
                />
                <Range v-else :values="TimesArray" type="double" />
                   <span class="highlight"></span><span class="bar"></span>
                   <label for="" >{{ $t("HomeHeader.FlightTime") }}</label>
              </div>

              <div class="card-text mb-4"></div>
              <hr />
              <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-plane filter-icon"></i>  {{ $t("HomeHeader.TicketType") }}
                </a>
                <PdkAirlineFilter
                  v-if="temp.availableFlights != null"
                  :airlines="returnAirlines"
                />
                <PdkAirlineFilter v-else />
              </div>
              <div class="filter_type filter-icon">
                <hr />
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i class="icon icon-ticket-2"></i> {{ $t("HomeHeader.TicketType") }}
                </a>

                <ul>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                       :title=" $t('HomeHeader.Economy')"
                    />
                  </li>
                  <li>
                    <pdk-ckeckbox
                      class="checkBox"
                      type="checkbox"
                      name="airline"
                      value="12"
                      :title=" $t('HomeHeader.Business')"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="box_style_2">
            <i class="icon_set_1_icon-57"></i>
            <h4>
              {{ $t("HomeHeader.DoYouNeedHelp") }}
            </h4>
            <a style="direction: ltr" href="tel://021446313605" class="phone"
              >021-44631360-5</a
            >
            <a style="direction: ltr" href="tel://021446313605" class="phone"
              >09045425792</a
            >
          </div>
        </aside>
       
    
          <div
          v-if="showNotFoundFlight || showNotFoundRoom || eventScheduleList.length > 0 "
          class="avail-container col-lg-9 col-md-8 col-sm-12"
        >

        <div v-if="eventScheduleList.length > 0" class="box_style_1">
        <h3 class="inner"> {{ $t("SearchResults.YourChosenRange") }} !</h3>
        <h6 style="color: #00c3e1;"> {{ $t("SearchResults.UseThisRange") }} .</h6>
        <hr />

        <div class="row">
          <div``
            v-for="(item, indx) in eventScheduleList"
            :key="indx"
            class="col-md-4"
          >
            <a
              @click="goToEvent(item.fromDate, item.toDate)"
              style="cursor:pointer !important; margin-bottom: 5px"
              class="btn_full_outline"
              ><span style="cursor:pointer">{{ item.title }}</span></a
            >
          </div>
        </div>
      </div>

          <FlightNotFound
            v-if="showNotFoundFlight"
            @notFoundAction="onFlightNotFoundAction"
            :withoutChangeDate="true"
          />
          <RoomNotFound
            @notFoundAction="onRoomNotFound($event)"
            v-if="showNotFoundRoom"
            :withoutChangeDate="true"
          >
            <div style="text-align: center" slot="message">
              <img
                id="timer-logo"
                width="150"
                height="150"
                src="../../../public/img/vector-hotel.png"
              />

              <h4 style="margin-top: 10px">
                {{ $t("SearchResults.SorryFreeHotel") }} 
                <span>  {{ $t("SearchResults.NotFound") }} .</span>
              </h4>
            </div>
          </RoomNotFound>


        </div>
        <div
          v-if="!showNotFoundFlight && !showNotFoundRoom &&  eventScheduleList.length === 0"
          class="avail-container col-lg-9 col-md-12 col-sm-12 col-xs-12"
        >
          <div>
            <div class="card p-4" v-if="step < 3">
              <div class="flight_title">
                <h2>
                   {{ $t("SearchResults.FlightChoose") }}  <span v-if="step === 1">{{ $t("SearchResults.Departure") }}</span>
                  <span v-if="step === 2">{{ $t("SearchResults.Arrival") }}</span>
                </h2>
              </div>

              <SklAvailCard v-if="isLoadingFlight" />
              <div v-else>
                <div
                  v-if="
                    step == 1 &&
                    this.selected.departureFlight !== null &&
                    this.selected.returnFlights !== null
                  "
                >
                  <PdkFlightSort
                    @sortBy="sortDepartureFlightBy"
                  ></PdkFlightSort>

                  <PdkFlightAvail
                    v-for="(flight, index) in temp.availableFlights
                      .departureFlights"
                    :key="index"
                    :showPrice="isShowPrice"
                    :availableFlight="flight"
                    :selectedFlight="selected.departureFlight"
                    @selected="onDepurtureSelect"
                  />
                </div>
              </div>
              <div v-if="step == 2 && this.selected.returnFlights !== null">
                <PdkFlightSort @sortBy="sortReturnFlightBy"></PdkFlightSort>
                <PdkFlightAvail
                  v-for="(flight, index) in temp.availableFlights.returnFlights"
                  :key="index"
                  :showPrice="isShowPrice"
                  :availableFlight="flight"
                  :selectedFlight="selected.returnFlight"
                  @selected="onReturnSelect"
                />
              </div>
              <div v-if="step == 2 && this.selected.returnFlights === null">
                پرواز برگشت یافت نشد
              </div>
            </div>
          </div>
        </div> 
    
       
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Range from "@/components/PdkRange";
import PdkFlightSort from "@/components/flight/FlightSort";
import PdkAirlineFilter from "@/components/shared/AirlineFilter";
import CheckBox from "@/components/PdkCheckBox";
import PdkFlightAvail from "@/components/flight/FlightAvail";
import Selected from "@/components/tour/SelectedHotelFlight";
import ChangeSearch from "@/components/tour/ChangeSearch";
import Rooms from "@/components/tour/Rooms";
import dateUtil from "../../utils/date";
import Store from "../../views/tour/store/index";
import SklAvailCard from "@/components/shared/Skeletons/SKLAvailCard";
import FlightNotFound from "@/components/flight/FlightNotFound";
import RoomNotFound from "../../components/tour/HotelNotFound";

import PDKModal from "@/components/PDKAlertModal";
require("linqjs");
require("bootstrap");

export default {
  store: Store,
  name: "TourFlight",
  components: {
    "pdk-ckeckbox": CheckBox,
    PDKModal,
    SklAvailCard,
    Range,
    PdkFlightSort,
    PdkAirlineFilter,
    PdkFlightAvail,
    Selected,
    ChangeSearch,
    FlightNotFound,
    RoomNotFound,
    Rooms,
  },

  data() {
    return {
  
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      isDisableButton: false,
      isShowPrice: true,
      showTimerModal: false,
      timer: "",
      roomsAvail: [],
      isShowChangeSearch: false,
      step: 1,
      selected: { departureFlight: null, returnFlight: null },
      items: { departureFlights: [], returnFlights: [] },
      roomItems: { availableRooms: [], recommendedRoom: {} ,eventScheduleResponses:[] },
      temp: {},
      departureAirlines: [],
      returnAirlines: [],
      searchItems: {},
      params: {},
      isLoadingFlight: true,
      selectedRoom: [],
          eventScheduleList:[],
      skletonModel: {
        isDeparture: false,
        isReturn: false,
        isToway: false,
        isRoom: false,
        isTotalPrice: false,
      },
      showNotFoundFlight: false,
      showNotFoundRoom: false,
      hotelId: 0,
      hotelDetails: {},
    };
  },

  created() {
    this.$store.dispatch("Book/BookingDetailsEmpty");

    this.params = this.$route.query;
        this.getFlight();
    this.getSearchItems();
    this.timer = setTimeout(() => {
      this.searchTimeout();

      this.isDisableButton = true;
    }, 600000);
  },
  mounted() {

  },
  methods: {
    goToEvent(startDate , endDate) {

       

   this.$router
        .push({
          name: "hotelFlight",
          query: {
            origin: this.params.origin,
            destination: this.params.destination,
            originName: this.params.originName,
            destinationName: this.params.destinationName,
            fromDate: startDate,
            toDate: endDate,
            rooms: this.params.rooms,
          },
        })
        .catch(() => {});
    },
    onRoomNotFound() {
      this.$router.push({
        path: "/",
      });
    },
    onSelectPackage(value) {
      this.$store.dispatch("Book/SelectedPackage", value);

      this.$router
        .push({
          path: "book",
          name: "FlightHotel Booking",
          query: {
            origin: this.params.origin,
            destination: this.params.destination,
            originName: this.params.originName,
            destinationName: this.params.destinationName,
            fromDate: this.params.fromDate,
            toDate: this.params.toDate,
            rooms: this.params.rooms,
          },
        })
        .catch(() => {});
    },
    onTimeoutModalAction() {
      window.location.reload();
    },
    searchTimeout() {
      this.showTimerModal = true;
    },
    onSelectRoom(option) {
      this.selectedRoom = option;
      this.skletonModel.isRoom = true;
      setTimeout(() => {
        this.skletonModel.isRoom = false;
      }, 1200);
    },
    onFlightNotFoundAction(event) {
      this.$router.push({
        path: "/",
      });
    },
    onChange(val) {
      this.step = val;
    },
    getSearchItems() {
      var rooms = JSON.parse(this.params.rooms);
      var pax = 0;
      var fromDate = dateUtil.ConvertToPersian(this.params.fromDate);
      var toDate = dateUtil.ConvertToPersian(this.params.toDate);
      pax = this.getChildren + this.getAdaults + this.getInfants;
      this.searchItems = {
        origin: this.params.originName,
        destination: this.params.destinationName,
        fromDate: fromDate,
        toDate: toDate,
        pax: pax,
        rooms: rooms,
        roomsCount: rooms.length,
      };
    },
    async sortDepartureFlightBy(sort) {
      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }
      var ascending = this.ascending;

      this.temp.availableFlights.departureFlights.sort(function (a, b) {
        if (a[sort] > b[sort]) {
          return ascending ? 1 : -1;
        } else if (a[sort] < b[sort]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    async sortReturnFlightBy(sort) {
      if (this.sortType === sort) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortType = sort;
      }
      var ascending = this.ascending;

      this.temp.returnFlights.sort(function (a, b) {
        if (a[sort] > b[sort]) {
          return ascending ? 1 : -1;
        } else if (a[sort] < b[sort]) {
          return ascending ? -1 : 1;
        }
        return 0;
      });
    },
    async getFlight() {
      if (this.params.destination === "MHD") {
        this.hotelId = 9;
      } else if (this.params.destination === "KIH") {
        this.hotelId = 4;
      }
      //جهت تست مسیر تست
      else {
        this.hotelId = 4;
      }
      var sourceId = localStorage.getItem("SourceIdInReport");
      const request = {
        origin: this.params.origin,
        destination: this.params.destination,
        departureDate: this.params.fromDate,
        returnDate: this.params.toDate,
        adultQuantity: this.getAdaults,
        childQuantity: this.getChildren,
        infantQuantity: this.getInfants,
        hotelId: this.hotelId,
        sourceId: sourceId,
      };

      this.items = await this.$store.dispatch(
        "Flight/AvailableFlights",
        request
      );
      console.log("this.items", this.items);
      const departureLength =
        this.items.availableFlights.departureFlights.length;
      const returnLength = this.items.availableFlights.returnFlights.length;
      this.$store.dispatch("Book/SetHotelId", this.hotelId);
      this.isLoadingFlight = false;
      if (departureLength > 0 && returnLength > 0) {
        this.temp = JSON.parse(JSON.stringify(this.items));

        this.departureAirlines =
          this.temp.availableFlights.departureFlights.groupBy(
            (t) => t.airLineName
          );
        this.returnAirlines = this.temp.availableFlights.returnFlights.groupBy(
          (t) => t.airLineName
        );
        this.selected.departureFlight =
          this.temp.recommendedFlight.departureFlight;
        this.selected.returnFlight = this.temp.recommendedFlight.returnFlight;
        this.isShowPrice = this.temp.showPrice;
        this.getRooms();
      } else {
        this.showNotFoundFlight = true;
        this.selected.departureFlight = null;
        this.selected.returnFlight = null;
      }
      // loader.hide();
    },
    async getRooms() {
      if (this.params.destination === "MHD") {
        this.hotelId = 14;
      } else if (this.params.destination === "KIH") {
        this.hotelId = 4;
      }

      //جهت مسیر تست
      else {
        this.hotelId = 4;
      }
      this.skletonModel.isRoom = true;
      const request = {
        origin: this.params.origin,
        destination: this.params.destination,
        arrivalDate: this.params.fromDate,
        departureDate: this.params.toDate,
        roomDetails: JSON.parse(this.params.rooms),
        hotelId: this.hotelId,
      };


 this.$store
        .dispatch( "Hotel/AvailableRooms",request)
        .then((res) => {
         
          if (Object.keys(res).length) {
            console.log('res.data',res)
        this.skletonModel.isRoom = false;
    
          console.log('res.eventScheduleResponses' , res.eventScheduleResponse)
          this.eventScheduleList = res.eventScheduleResponse;
         
           console.log('this.eventScheduleList' , this.eventScheduleList )
        this.hotelDetails = res.hotelDetail;
      

        if (this.eventScheduleList.length === 0) {
          this.roomsAvail = res;
          this.selectedRoom = this.roomsAvail.availableRooms[0];
        }

          }
                 else {
        this.showNotFoundRoom = true;
      }
        });
   

//       const temp = JSON.parse(JSON.stringify(this.roomItems));
//       if (Object.keys(temp).length > 0) {


    },
    filterByDepartureTime(value) {
      const date = moment(this.$route.query.fromDate).format("YYYY/MM/DD");
      const from = moment(`${date} ${value.fromValue}`, "YYYY/MM/DD HH:mm");
      const to = moment(`${date} ${value.toValue}`, "YYYY/MM/DD HH:mm");
      this.temp.availableFlights.departureFlights = JSON.parse(
        JSON.stringify(this.items.availableFlights.departureFlights)
      );
      this.temp.availableFlights.departureFlights =
        this.temp.availableFlights.departureFlights.where(
          (t) =>
            moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrBefore(
              to
            ) &&
            moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrAfter(from)
        );
    },
    filterByReturnTime(value) {
      const date = moment(this.$route.query.toDate).format("YYYY/MM/DD");
      const from = moment(`${date} ${value.fromValue}`, "YYYY/MM/DD HH:mm");
      const to = moment(`${date} ${value.toValue}`, "YYYY/MM/DD HH:mm");
      this.temp.availableFlights.returnFlights = JSON.parse(
        JSON.stringify(this.items.returnFlights)
      );
      this.temp.availableFlights.returnFlights =
        this.temp.availableFlights.returnFlights.where(
          (t) =>
            moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrBefore(
              to
            ) &&
            moment(t.departureDateTime, "YYYY/MM/DD HH:mm").isSameOrAfter(from)
        );
    },
    onDepurtureSelect(item) {
      this.step = 2;
      this.selected.departureFlight = item;
      this.skletonModel.isDeparture = true;
      this.skletonModel.isReturn = false;
      setTimeout(() => {
        this.skletonModel.isDeparture = false;
      }, 1200);
    },
    onReturnSelect(item) {
      this.step = 4;
      this.selected.returnFlight = item;
      this.skletonModel.isReturn = true;
      this.skletonModel.isDeparture = false;
      setTimeout(() => {
        this.skletonModel.isReturn = false;
      }, 1200);
    },
    onDepartureEdit() {
      this.selected.departureFlight =
        this.temp.recommendedFlight.departureFlight;
      this.selected.returnFlight = this.temp.recommendedFlight.returnFlight;
      this.step = 1;
    },
    onReturnEdit() {
      this.step = 2;
      this.selected.returnFlight = this.temp.recommendedFlight.returnFlight;
    },
  },
  computed: {
    getAdaults() {
      const params = this.$route.query;
      return JSON.parse(params.rooms).sum((t) => t.adults);
    },
    getChildren() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalChild = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age >= 2) {
            totalChild = totalChild + 1;
          }
        });
      });
      return totalChild;
    },
    getInfants() {
      const params = this.$route.query;
      var rooms = JSON.parse(params.rooms);
      var totalInfant = 0;

      rooms.forEach((room) => {
        room.kinderAge.forEach((age) => {
          if (age < 2) {
            totalInfant = totalInfant + 1;
          }
        });
      });
      return totalInfant;
    },
    TimesArray() {
      let arr = [];
      for (let i = 0; i <= 22; i++) {
        const d = new Date();
        d.setHours(i, 0, 0, 0);
        arr.push(d.toTimeString().substring(0, 5));
      }
      arr.push("23:59");
      return arr;
    },
  },
};
</script>

<style scoped>
.bar label {
    margin-top: -38px;}
    
@media only screen and (max-width: 750px) {
  .avail-container {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .filter-sidebar {
    display: none !important;
  }
}
.margin_container_hf{
  margin-top: 125px;
  padding: 20px 70px;
}
.filter-sidebar {
  flex: 0 0 27%;
  max-width: 27%;
}

.avail-container {
  flex: 0 0 73%;
  max-width: 73%;
}
.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}
.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>